import type {Step} from "../../components/stepper/Step.ts";
import {useAtomValue} from "jotai";
import {ConnectionAtom, isConnectionValid} from "./MetlConnectionProperties.ts";
import {MetlConnectionWidget} from "./MetlConnectionWidget.tsx";

export function useMetlConnectionStep(): Step {
    const metlConnection = useAtomValue(ConnectionAtom)
    return {
        isAvailable: true,
        isCompleted: isConnectionValid(metlConnection),
        name: "Metl Connection",
        Widget: MetlConnectionWidget
    }
}